import { render } from "./originPlasticSource.vue?vue&type=template&id=da507a12&scoped=true&ts=true"
import script from "./originPlasticSource.vue?vue&type=script&lang=ts"
export * from "./originPlasticSource.vue?vue&type=script&lang=ts"

import "./originPlasticSource.vue?vue&type=style&index=0&id=da507a12&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da507a12"]])

export default __exports__